import { RoutePermissionModel } from "./casl-permissions.model";


export class GetRoutePermissions {
    static readonly type = '[Casl Permissions] Get Route Permissions';
    constructor(public payload: { gridUUID: string; }) { };
}

export class GetRolePermissions {
    static readonly type = '[Casl Permissions] Get Role Permissions';
    constructor(public payload: { gridUUID: string; }) { };
}

export class SetCaslPermissionType {
    static readonly type = '[Casl Permissions] Set Casl Permission Type';
    constructor(public payload: { caslPermissionType: string; }) { };
}

export class GetRegisteredAPIModels {
    static readonly type = '[Casl Permissions] Get Registered API Models';
    constructor() { };
}

export class GetRegisteredAPIRoutes {
    static readonly type = '[Casl Permissions] Get Registered API Routes';
    constructor() { };
}

export class SubmitRoutePermission {
    static readonly type = '[Casl Permissions] Submit Route Permission';
    constructor() { };
}

export class DeleteRoutePermission {
    static readonly type = '[Casl Permissions] Delete Route Permission';
    constructor(public payload: { routePermission: RoutePermissionModel }) { };
}

export class SetSelectedRoutePermission {
    static readonly type = '[Casl Permissions] Set Selected Route Permission';
    constructor(public payload: { _id: string, md5Checksum: string; }) { };
}


export class GetRoleDropdownOptions {
    static readonly type = '[Casl Permission] Get Role Dropdown Options';
    constructor(public payload: string[]) {}
}


